import { Modal, notify } from "@general-backoffice/core";
import { QRCodeCanvas } from "qrcode.react";
import React from "react";
import { useTranslation } from "react-i18next";

interface QRCodeModalProps {
  value: string;
  filename: string;
  close: () => void;
}

const QRCodeModal = ({ value, filename, close }: QRCodeModalProps) => {
  const { t } = useTranslation("modals", { keyPrefix: "QRCodeModal" });

  const downloadQR = () => {
    const el = document.getElementById("qr-code");
    if (!(el instanceof HTMLCanvasElement)) return;
    const url = el.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = filename + ".png";
    link.href = url;
    link.click();
    notify.info(t("downloadedText"));
  };

  return (
    <>
      <Modal.Simple
        color="default"
        isOpen={!!value}
        toggleOpen={close}
        closeText={t("closeText")}
        buttons={[{ color: "primary", children: t("download"), onClick: downloadQR }]}
      >
        <QRCodeCanvas id="qr-code" value={value} size={500} style={{ maxWidth: "100%" }} includeMargin />
      </Modal.Simple>
    </>
  );
};

export default QRCodeModal;
